import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { colors, menuOffset } from "../../theme";
import { Offer, OfferTitle, OfferButton, More } from "./supportTheme";

function SupportSocioOffer({ withButton, isResubscribing }) {
  return (
    <Offer isSocioPath isResubscribing={isResubscribing}>
      <OfferTitle color={colors.red}>
        {isResubscribing ? "Redevenir" : "Devenir"} Socio
      </OfferTitle>
      <h3>À partir de 5€/mois</h3>
      {!isResubscribing && <p>+ 5€ de parts sociales à l'inscription</p>}
      {withButton && (
        <OfferButton as={Link} to="/soutien/socio">
          Je {isResubscribing && "re"}deviens Socio
        </OfferButton>
      )}
      <ul>
        <li>
          <i className="fa-fw fas fa-check" /> Soutenez financièrement Le Média
        </li>
        <li>
          <i className="fa-fw fas fa-plus" /> Avantages abonnés
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Accès au forum
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Accès à l'équipe
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Participation aux tournages
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Places gratuites à des événements
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Droit politique dans le cadre de
          la coopérative
        </li>
      </ul>
      {/* <div>
        <strong>-50%</strong> de réduction d’impôts sur l’achat de parts
        sociales
      </div> */}
      {withButton && (
        <More
          to="SCIC"
          offset={-Math.abs(parseInt(menuOffset, 10) + 10)}
          isDynamic
          smooth
          duration={400}
        >
          En savoir plus
        </More>
      )}
    </Offer>
  );
}

SupportSocioOffer.propTypes = {
  withButton: PropTypes.bool,
  isResubscribing: PropTypes.bool,
};

export default SupportSocioOffer;
